"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Products = exports.ProductItem = exports.ProductContainer = void 0;
var _stitches = require("../../../../stitches.config");
var ProductContainer = exports.ProductContainer = (0, _stitches.styled)('div', {
  marginBottom: 20,
  '& ul': {
    marginX: 24
  },
  variants: {
    size: {
      mobile: {
        width: 375,
        marginX: 'auto'
      },
      tablet: {},
      desktop: {
        width: 340
      }
    }
  }
});
var Products = exports.Products = (0, _stitches.styled)('ul', {
  display: 'flex',
  flexDirection: 'column',
  listStyleType: 'none',
  paddingLeft: 0,
  marginY: 0,
  marginX: 'auto',
  variants: {
    size: {
      mobile: {},
      tablet: {},
      desktop: {
        flexDirection: 'row'
      }
    }
  }
});
var ProductItem = exports.ProductItem = (0, _stitches.styled)('li', {
  padding: 0
});
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-confirm-apply/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');